// Socket.IO-событие инвалидации карты доступности (ТЗ §6.4).
//
// Тумблер обязан влиять БЕЗ перезагрузки (Wire-up DoD): админ переключил
// модуль — сервер шлёт событие, клиент рефетчит `modules.availability` и
// перезаписывает офлайн-снапшот.

import { z } from "zod";

export const MODULES_AVAILABILITY_CHANGED_EVENT = "modules:availability_changed" as const;

export const modulesAvailabilityChangedPayloadSchema = z.object({
	/**
	 * Новое поколение карты. Клиент, у которого снапшот свежее пришедшего
	 * поколения (гонка «рефетч обогнал событие»), обязан НЕ откатываться назад.
	 */
	version: z.number().int().nonnegative(),
	/** Что именно изменилось — для точечной инвалидации и логов. */
	moduleIds: z.array(z.string()),
});
export type ModulesAvailabilityChangedPayload = z.infer<
	typeof modulesAvailabilityChangedPayloadSchema
>;
